import { findIndex, map } from 'lodash';

import { createSlice } from '@reduxjs/toolkit';

const treeSlice = createSlice({
    name: 'tree',
    initialState: {
        data: [],
    },
    reducers: {
        setTreeNode: (state, { payload }) => {
            const index = state.data.findIndex((n) => n.id === payload.id);

            if (index >= 0) {
                state.data[index] = payload;
            } else {
                state.data.push(payload);
            }
        },

        toggleTreeNodeOpen: (state, { payload }) => {
            const foundNodeIndex = findIndex(state.data, payload);
            state.data[foundNodeIndex] = {
                ...state.data[foundNodeIndex],
                isOpen: !payload.isOpen,
            };
        },

        closeTreeNode: (state, { payload }) => {
            const foundNodeIndex = findIndex(state.data, payload);
            state.data[foundNodeIndex] = {
                ...state.data[foundNodeIndex],
                isOpen: false,
            };
        },

        replaceTreeNode: (state, { payload }) => {
            state.data = map(state.data, (node) => (node.id === payload.id ? payload : node));
        },
    },
});

export default treeSlice.reducer;
export const { setTreeNode, toggleTreeNodeOpen, closeTreeNode, replaceTreeNode } =
    treeSlice.actions;
